import React from 'react'
import { Provider } from './Context'
import { Layout } from './Layout'

export const Page = () => {
  return (
    <Provider>
      <Layout />
    </Provider>
  )
}
